import React, { useState } from "react";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import BarekamText from "../../../../pages/components/text";
import { BarekamCard } from "../../../../pages/components/card/card";
import { GapContainer } from "../../../../pages/components/card/styled";
import { OrderGroupModel } from "../../../../pages/shared/models/order/orderGroupModel";
import { ThreeDot } from "../../../../pages/components/three-dot/three-dot";
import { GroupActionsByState } from "../../../actions/actions-by-state";
import { ActionBarActions } from "../../../actions/action-buttons";
import { useAppSelector } from "../../../../redux/store";
import {
  GenericActionTypes,
  InWarehouseActionTypes,
  OrderPopupActionTypes,
  ReadyForShipmentActionTypes,
} from "../../../actions/action-types.enum";
import { ActionDialog } from "../../../actions/dialogs/action-dialog";
import { GroupCardRowData } from "./group-card-row-data";

const cardRows = [
  { key: "dateCreated", rowName: "date_created", variant: "date" },
  { key: "destination", rowName: "destination", variant: "warehouse" },
  // {key: 'driverFullName', rowName: 'driver_full_name', variant: 'text'},
  // {key: 'driverCarInfo', rowName: 'driver_car_info', variant: 'text'},
  // {key: 'driverPhoneNumber', rowName: 'driver_phone_number', variant: 'text'},
  { key: "note", rowName: "note", variant: "text" },
  { key: "orders", rowName: "total_weight", variant: "totalWeight" },
  { key: "orders", rowName: "total_count", variant: "totalCount" },
];

export const GroupCard = ({ group }: GroupCardProps) => {
  const { orderStateId } = useAppSelector((state) => state.ordersReducer);
  const [activeAction, setActiveAction] = useState<
    | GenericActionTypes
    | InWarehouseActionTypes
    | ReadyForShipmentActionTypes
    | OrderPopupActionTypes
  >();

  const OrderHeaderLabel = () => (
    <BarekamText variant={"1rem"} fontWeight={700} width={"unset"}>
      {group.name}
    </BarekamText>
  );

  const CardContent = () => (
    <>
      {cardRows.map((row, index) => (
        <GapContainer key={index}>
          <BarekamText variant={"s"} opaque>
            <Message
              messageKey={row.rowName}
              sectionId={MessageSections.ORDERS}
            />
            {":"}
          </BarekamText>

          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <GroupCardRowData value={group[row.key]} variant={row.variant} />
        </GapContainer>
      ))}
    </>
  );

  const HeaderAction = () => {
    const actions = GroupActionsByState[orderStateId];

    function onActionFunctionClick(
      actionId:
        | InWarehouseActionTypes
        | ReadyForShipmentActionTypes
        | OrderPopupActionTypes
        | GenericActionTypes,
    ) {
      setActiveAction(actionId);
    }

    if (actions) {
      return (
        <ThreeDot>
          <ActionBarActions
            actions={actions}
            onClick={(actionId) => onActionFunctionClick(actionId)}
          />
        </ThreeDot>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <BarekamCard
        selected={false}
        headerLabel={<OrderHeaderLabel />}
        headerAction={<HeaderAction />}
        content={<CardContent />}
        hoverColor={"#FFF"}
      />

      <ActionDialog
        open={!!activeAction}
        closePopup={() => setActiveAction(undefined)}
        action={activeAction}
        orderStateId={orderStateId}
        predefinedOrders={group.orders}
        orderGroup={group}
      />
    </>
  );
};

interface GroupCardProps {
  group: OrderGroupModel;
}
